import { Outlet } from 'react-router-dom'
import { Stack, Text } from '@fluentui/react'
import { useAuth } from '../../auth/AuthProvider'
import { isCemEmployee } from '../../auth/isCemEmployee'
import UserMenu from '../../components/UserMenu/UserMenu'
import NavBar from '../../components/NavBar/NavBar'
import EnvSelector from '../../components/EnvSelector/EnvSelector'

const Layout = () => {
  const { isAuthenticated, user } = useAuth()
  const showApp = isAuthenticated && isCemEmployee(user)

  return (
    <Stack styles={{ root: { minHeight: '100vh' } }}>
      {/* Header */}
      <Stack
        horizontal
        verticalAlign="center"
        horizontalAlign="space-between"
        styles={{
          root: {
            padding: '12px 24px',
            backgroundColor: '#2B3A67',
            color: '#fff',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            zIndex: 1,
          },
        }}
      >
        <Text variant="xLarge" styles={{ root: { color: '#fff', fontWeight: 600 } }}>
          CEM Query Analytics
        </Text>
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 16 }}>
          {showApp && <EnvSelector />}
          {isAuthenticated && <UserMenu />}
        </Stack>
      </Stack>

      {/* Body: NavBar + Content */}
      <Stack horizontal styles={{ root: { flex: 1 } }}>
        {showApp && <NavBar />}
        <Stack styles={{ root: { flex: 1, padding: '24px', overflow: 'auto' } }}>
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  )
}

export default Layout
